module.exports = __webpack_public_path__ + "img/statistics-bg-2.cb30a9fa.png";